import { useTranslations } from 'next-intl';
import GamesListSection from '@/app/[locale]/(main)/casino/components/games-list';

type OriginalGamesListProps = {
  type: string;
};

const OriginalGamesList = ({ type }: OriginalGamesListProps) => {
  const t = useTranslations('landing.original-games');

  return (
    <GamesListSection
      isCarousel
      title={t('section-title')}
      type={type}
    />
  );
};

export default OriginalGamesList;
